import { gql } from "./api";

interface GetFakeEmailArticlesInput {
  uuid: string;
  token: string;
  page_number: number;
}

interface GetFakeEmailArticleInput {
  uuid: string;
  token: string;
  article_uuid: string;
}


export const getFakeEmailArticles = async ({
  uuid,
  token,
  page_number
}: GetFakeEmailArticlesInput) => {
  const response = await gql({
    query: `
      mutation GetAlertsArticles {
        getAlertsArticles(
          getAlertsArticlesInput: { 
            uuid: "${uuid}", 
            token: "${token}", 
            page_number: ${Math.floor(page_number)} 
          }
        ) {
          pagination
          alerts {
            uuid
            title
            content
            category
            logo
            email_image
            date
          }
        }
      }
    `,
    returnFunc: 'getAlertsArticles'
  });

  return response;
};

export const getFakeEmailArticle = async ({
  uuid,
  token,
  article_uuid
}: GetFakeEmailArticleInput) => {
  const response = await gql({
    query: `
        mutation GetCmsPage {
          getCmsPage(
              getCmsPageInput: { uuid: "${uuid}", token: "${token}", page_uuid: "${article_uuid}" }
          ) {
              page {
                  id
                  uuid
                  title
                  content
                  category
                  email_image
                  logo
                  date
              }
          }
      }
    `,
    returnFunc: 'getCmsPage'
  });

  return response;
};
